/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { SuccessResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class RequestAccess<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags access-controller
   * @name RequestAccess
   * @request GET:/requestAccess/{resource}
   * @secure
   * @response `200` `SuccessResponse` OK
   */
  requestAccess = (
    resource:
      | "LOCATION"
      | "ADVERTISER"
      | "SERVICE_PROVIDER"
      | "BACKOFFICE"
      | "SERVICES",
    params: RequestParams = {},
  ) =>
    this.request<SuccessResponse, any>({
      path: `/requestAccess/${resource}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
